<div class="clr"></div>

<div  class="subResult">
  <mat-toolbar  *ngIf="rowData == ''" class="mat-toolbar listps fontPS" color="accent" style="color:#000">

    <div style="width: 100%;text-align: center;">

      No Records to Show

    </div>

  </mat-toolbar>

  <div class="wrapper">
    <!-- <div class="block_line" color="accent"></div> -->
    <mat-nav-list>
      <div *ngIf="showLoading">
        <div class="lmask"></div>
      </div>

      <div *ngFor="let searchdata of rowData;index as i">
        <div class="pl-2 button-center">
          <button mat-raised-button class="certDetailsBtn" (click)="getCertificateData(searchdata.powerSupplyCertifications.psCertificationId)" title="View Certification"
          ><b></b>View Details</button></div>

        <p class="pl-2" mat-list-item><b>Certificate Date: </b>{{searchdata.powerSupplyCertifications.certificationDate | date :'MM/dd/yyyy, h:mm:ss a' }}</p>
        <p class="pl-2" mat-list-item><b>Technician Name: </b>{{searchdata.powerSupplyCertifications.technicianName}}</p>
        <p class="pl-2" mat-list-item><b>Mac Address: </b>{{searchdata.powerSupplyCertifications.macAddress}} </p>
        <p class="pl-2" mat-list-item><b>Type of Visit: </b>{{searchdata.powerSupplyCertifications.typeOfVisit}}</p>
        <p class="pl-2" mat-list-item><b>Inspection Date: </b>{{searchdata.powerSupplyCertifications.inspectionDate | date :'MM/dd/yyyy'}}</p>
        <p class="pl-2" mat-list-item><b>Status: </b>{{searchdata.powerSupplyCertifications.isActive}}</p>
        <p class="pl-2" mat-list-item><b>Last Updated By: </b>{{searchdata.powerSupplyCertifications.logName}}</p>
        <p class="pl-2" mat-list-item><b>Last Updated Date: </b>{{searchdata.powerSupplyCertifications.logDate | date :'MM/dd/yyyy, h:mm:ss a'}}</p>


        <div class="block_line" color="accent"></div>
      </div><br>
    </mat-nav-list>
  </div>
</div>
